import React from 'react';
import { SectionTelegramWrapper } from './styles';
import { RiTelegramLine } from 'react-icons/ri';
import IPhoneComponent from '@/components/IPhone';
import { BsTelegram } from 'react-icons/bs';
import telegramGif from "../../img/6.mp4";
import { useNavigate } from 'react-router-dom';

interface TelegramSectionProps {
  // Se necessário, você pode declarar propriedades aqui
}

const TelegramSection: React.FC<TelegramSectionProps> = () => {
  const navigate = useNavigate()

  const handleButton = () => {
    window.location.href = "https://t.me/+0XlLbS09R6xiMGEx"
  }
  return (
    <SectionTelegramWrapper>
    <div className="row-primary">
      <div className="col-cta">
        <h1>
          <RiTelegramLine />GRUPO GRATUITO
        </h1>
        <br />
        <p>
          No nosso grupo FREE, o Vitor compartilha insights valiosos e estratégias certeiras para você brilhar nas apostas esportivas.
        </p>
        <br />
        <p>
          E o melhor? Você terá uma amostra gratuita do Futscore, para aproveitar o melhor do futebol com a nossa assistência especializada.
        </p>
      </div>
      <div className="col-phone">
        <IPhoneComponent active={true} src={telegramGif} />
      </div>
      <button onClick={() => handleButton()}>ENTRAR GRATUITAMENTE <BsTelegram /> </button>
    </div>
  </SectionTelegramWrapper>
  );
};

export default TelegramSection;
